import AuthGuard from './middleware/auth-guard'

export default function middleware (router) {
  AuthGuard(router)
}



// WEBPACK FOOTER //
// ./src/middleware.js